import React from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import HeadContainer from '../../../common/head-container';

const AlreadyRegistered = ({ setScreenNumber, telegramLink, utm_campaign }) => {
  const handleReviewButtonClick = () => {
    sessionStorage.setItem('r_b', 'true');
    window.location.href = `https://yourjourney.com.ua/${utm_campaign}`;
  };

  const handleContentButtonClick = () => {
    sessionStorage.setItem('r_b', 'false');
    window.location.href = `https://yourjourney.com.ua/${utm_campaign}`;
  };

  return (
    <div
      className={styles.container}
      style={{
        backgroundImage: `url("${getImageFromS3('images/ua-brand/bg.png')}")`
      }}
    >
      <div style={{ padding: '40px 0' }}>
        <HeadContainer
          setScreenNumber={setScreenNumber}
          telegramOnly
          customTelegramLink={telegramLink}
        />
      </div>
      <p className={styles.title}>Супер!</p>
      <p className={styles.description}>
        Бачимо, що <b>ти реєструвався</b> <br></br>раніше.
      </p>
      <div className={styles.buttonContainer}>
        <div
          className={styles.feedbackButton}
          onClick={handleReviewButtonClick}
        >
          <img
            src={getImageFromS3('images/ua-brand/bonuses-button.png')}
            alt="bonuses-button"
          />
          <p>
            <b>Залишити відгук</b> про продукт <b>і отримати бонус</b>
          </p>
          <svg
            width="33"
            height="33"
            viewBox="0 0 33 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="16.5" cy="16.5" r="16.5" fill="#7840BA" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.6781 9.58924C14.3702 9.26852 13.8547 9.26072 13.5421 9.57683C13.2409 9.88147 13.2372 10.3707 13.5339 10.6798L18.9453 16.3182C19.3166 16.7051 19.3167 17.316 18.9454 17.7029L18.9051 17.745L18.9086 17.7409L13.5617 23.3114C13.2682 23.6172 13.2682 24.1003 13.5618 24.4061C13.8729 24.7301 14.39 24.7312 14.7011 24.4071C16.3753 22.6629 19.4584 19.4508 21.1373 17.7017C21.5086 17.3149 21.5079 16.705 21.1366 16.3181C20.6214 15.781 19.6934 14.8142 14.6781 9.58924Z"
              fill="white"
            />
          </svg>
        </div>
        <div className={styles.contentButton}>
          <img
            src={getImageFromS3('images/ua-brand/content-button.png')}
            alt="bonuses-button"
          />
          <p>
            До <b>контенту</b>
          </p>
          <svg
            width="33"
            height="33"
            viewBox="0 0 33 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={handleContentButtonClick}
          >
            <circle cx="16.5" cy="16.5" r="16.5" fill="#7840BA" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.6781 9.58924C14.3702 9.26852 13.8547 9.26072 13.5421 9.57683C13.2409 9.88147 13.2372 10.3707 13.5339 10.6798L18.9453 16.3182C19.3166 16.7051 19.3167 17.316 18.9454 17.7029L18.9051 17.745L18.9086 17.7409L13.5617 23.3114C13.2682 23.6172 13.2682 24.1003 13.5618 24.4061C13.8729 24.7301 14.39 24.7312 14.7011 24.4071C16.3753 22.6629 19.4584 19.4508 21.1373 17.7017C21.5086 17.3149 21.5079 16.705 21.1366 16.3181C20.6214 15.781 19.6934 14.8142 14.6781 9.58924Z"
              fill="white"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default AlreadyRegistered;
